import React, { useState } from 'react';
import { 
  Container, 
  Box, 
  Typography, 
  Tabs, 
  Tab, 
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';
import P2PMarketplace from './P2PMarketplace';
import P2PBuyInterface from './P2PBuyInterface';
import P2PSellInterface from './P2PSellInterface';
import P2PHistory from './P2PHistory';

export default function P2P() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant={isMobile ? "h5" : "h4"} 
          component="h1" 
          sx={{ 
            fontWeight: 700,
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 1
          }}
        >
          P2P Trading
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ 
            color: 'text.secondary',
            fontSize: isMobile ? '0.9rem' : '1rem'
          }}
        >
          Trade cryptocurrencies directly with other users at competitive rates
        </Typography>
      </Box>

      {/* Main Content */}
      <Paper 
        elevation={2} 
        sx={{ 
          borderRadius: 3,
          overflow: 'hidden',
          backgroundColor: theme.palette.mode === 'dark' ? 'grey.900' : 'background.paper'
        }}
      >
        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            variant={isMobile ? "fullWidth" : "standard"}
            sx={{
              '& .MuiTab-root': {
                minHeight: 60,
                fontSize: isMobile ? '0.9rem' : '1rem',
                fontWeight: 600,
                textTransform: 'none',
                px: isMobile ? 2 : 4
              }
            }}
          >
            <Tab 
              icon={<TrendingUp />} 
              label="Buy Crypto" 
              iconPosition="start"
              sx={{ 
                color: activeTab === 0 ? 'success.main' : 'text.secondary',
                '&.Mui-selected': {
                  color: 'success.main',
                  bgcolor: `${theme.palette.success.main}10`
                },
                '&:hover': {
                  bgcolor: `${theme.palette.success.main}05`
                },
                transition: 'all 0.3s ease'
              }}
            />
            <Tab 
              icon={<TrendingDown />} 
              label="Sell Crypto" 
              iconPosition="start"
              sx={{ 
                color: activeTab === 1 ? 'error.main' : 'text.secondary',
                '&.Mui-selected': {
                  color: 'error.main',
                  bgcolor: `${theme.palette.error.main}10`
                },
                '&:hover': {
                  bgcolor: `${theme.palette.error.main}05`
                },
                transition: 'all 0.3s ease'
              }}
            />
            <Tab 
              label="History" 
              sx={{ 
                color: activeTab === 2 ? 'primary.main' : 'text.secondary',
                '&.Mui-selected': {
                  color: 'primary.main',
                  bgcolor: `${theme.palette.primary.main}10`
                },
                '&:hover': {
                  bgcolor: `${theme.palette.primary.main}05`
                },
                transition: 'all 0.3s ease'
              }}
            />
          </Tabs>
        </Box>

        {/* Tab Content */}
        <Box sx={{ p: 0 }}>
          {activeTab === 0 && (
            <P2PBuyInterface />
          )}
          {activeTab === 1 && (
            <P2PSellInterface />
          )}
          {activeTab === 2 && (
            <P2PHistory />
          )}
        </Box>
      </Paper>
    </Container>
  );
}
